// The Account cell's hover wrapper and chip group, shared by the board, Accounts, Available and
// AE tables so the card and the narrow-column behaviour are one thing.
//
// The wrapper is the container the narrow-column rules in board.css query: when the cell is too
// narrow, the employee count drops first, then the chips collapse into one "+N" chip, so the
// name keeps at least ~110px.

import type { ReactNode } from 'react';
import { HoverCard } from '../components/HoverCard';
import { AccountCard } from './boardHoverCards';
import type { AccountCardFact } from './accountCard';
import type { RankedAccount } from './derived';

export function AccountHover({
  row, name, today, requestFacts, forceOpen, children,
}: {
  row: RankedAccount | null;
  name: string;
  today: Date;
  requestFacts?: AccountCardFact[];
  forceOpen?: boolean;
  children: ReactNode;
}) {
  return (
    <HoverCard
      card={() => <AccountCard row={row} name={name} today={today} requestFacts={requestFacts} />}
      label={`Account: ${name}`}
      className="dacctcard"
      forceOpen={forceOpen}
    >
      {children}
    </HoverCard>
  );
}

// The `data-chips` value for the cell's root: the chip count, capped at four.
export function chipsAttribute(count: number): number {
  return Math.min(count, 4);
}

// The chips, and the "+N" chip that stands for them when the column is too narrow for them.
export function AccountChips({ count, children }: { count: number; children: ReactNode }) {
  if (count === 0) return null;
  return (
    <>
      <span className="dchips">{children}</span>
      <span className="ovflag dmore" aria-hidden="true">+{count}</span>
    </>
  );
}
